import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { ESpinType } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useSpinTypeSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.spin),
                value: ESpinType.Spin,
            },
            {
                label: intl.formatMessage(message.spinback),
                value: ESpinType.Spinback,
            },
            {
                label: intl.formatMessage(message.static),
                value: ESpinType.Static,
            },
        ],
        [intl],
    )
}
